export const modals = {
	confirmProductToggle: {
		deactivateProduct: "Desactivar producto",
		activateProduct: "Activar producto",
		confirmModalDescription: "¿Deseas {{action}} los productos montables que compone?",
	},
	confirmToggle: {
		deactivateProduct: "Desactivar producto",
		activateProduct: "Activar producto",
		toggleProducts: "Alternar solo este producto",
	},
	deleteCategory: {
		title: "Eliminar categoría",
		cancelButton: "Cancelar",
		moveAndDeleteButton: "Mover productos y eliminar categoría",
		deleteButton: "Eliminar categoría",
		newCategoryLabel: "Nueva categoría",
		selectNewCategoryPlaceholder: "Seleccionar nueva categoría",
		categoryDeletedSuccess:
			'La categoría "{{categoryName}}" ha sido eliminada exitosamente.',
		categoryDeletedAndProductsMovedSuccess:
			'La categoría "{{categoryName}}" ha sido eliminada y sus productos han sido ' +
			'movidos a "{{newCategoryName}}".',
		categoryWithProductsDescription:
			"Esta categoría tiene <strong>{{productCount}} producto vinculado</0>. " +
			"Antes de eliminar la categoría necesitas mover los productos a otra categoría",
		categoryWithProductsDescription_plural:
			"Esta categoría tiene <strong>{{productCount}} productos vinculados</0>. " +
			"Antes de eliminar la categoría necesitas mover los productos a otra categoría",
		confirmDeleteCategoryDescription:
			"¿Estás seguro de que quieres eliminar esta categoría? <strong>Esta acción no se puede deshacer.</0>",
	},
	massEdit: {
		title: "Edición masiva de productos",
		completeButton: "Completar",
		comingSoon: "Próximamente: flujo de edición masiva",
		selectedCount: "{{count}} {{unit}} seleccionado",
		selectedCount_plural: "{{count}} {{unit}} seleccionados",
		instruction:
			'Haz clic en "Completar" para proceder con la eliminación de la categoría.',
	},
	duplicateProductDrawer: {
		title: "Duplicar producto montable",
		stepTitles: {
			duplicateProduct: "Duplicar Producto",
			selectProducts: "Seleccionar Productos",
		},
		duplicationChoice: {
			createNewProduct: {
				title: "Crear nuevo producto montable",
				description: "Duplicar el montable para usar en un nuevo producto",
			},
			batchDuplicate: {
				title: "Importar duplicado en lote",
				description: "Importar el paso montable a productos ya creados",
			},
		},
		actions: {
			cancel: "Cancelar",
			back: "Regresar",
			duplicate: "Duplicar montable",
			addProducts: "Agregar productos",
			comingSoon: "Esta funcionalidad se implementará próximamente",
			noMountableData: "No hay datos montables para duplicar",
		},
		productSelection: {
			label: "Selecciona los productos que recibirán el montable:",
			placeholder: "Seleccionar productos...",
			selectedProducts: "Productos seleccionados",
			emptyState: {
				title: "Ningún producto seleccionado",
				description: "Agrega los productos a los que quieres duplicar el montable",
			},
			successMessage:
				'Las configuraciones de "{{productName}}" se aplicaron a {{count}} producto exitosamente.',
			successMessage_plural:
				'Las configuraciones de "{{productName}}" se aplicaron a {{count}} productos exitosamente.',
		},
	},
	deleteProduct: {
		cancel: "Cancelar",
		delete: "Eliminar",
		confirmDeleteMessage:
			'¿Está seguro de que desea eliminar el producto <strong>"{{productName}}"</strong>?',
	},
	deleteProducts: {
		title: "Eliminar productos seleccionados {{count}}",
		cancelButton: "Cancelar",
		deleteButton: "Eliminar producto",
		deleteButton_plural: "Eliminar {{count}} productos",
		description:
			"Los {{count}} productos seleccionados serán eliminados de este lugar y esta acción no se " +
			"puede deshacer (podrá verlos a nivel org).",
		confirmQuestion: "¿Está seguro de que desea continuar?",
		deleteSuccess: "Producto eliminado exitosamente",
		deleteSuccess_plural: "{{count}} productos eliminados exitosamente",
	},
	exitMassEditMode: {
		title: "¿Salir del modo de edición masiva?",
		description:
			"Tiene productos seleccionados. Al navegar a otra categoría, la selección se perderá.",
		confirmButton: "Sí, salir",
		cancelButton: "Cancelar",
	},
};
